// import React, { useState, useEffect } from 'react';
// import { ref, get, set } from 'firebase/database';
// import { ref as storageRef, uploadBytes, getDownloadURL, deleteObject } from 'firebase/storage';
// import { database, storage } from '../firebase';
// import { toast } from 'react-toastify';

// const OrderDocumentsTable = () => {
//   const [documents, setDocuments] = useState([
//     { sNo: 1, name: 'TRUST REGISTRATION', pdfUrl: null },
//     { sNo: 2, name: 'NOC', pdfUrl: null },
//     { sNo: 3, name: 'RECOGNITION CERTIFICATE', pdfUrl: null },
//     { sNo: 4, name: 'BUILDING SAFETY CERTIFICATE', pdfUrl: null },
//     { sNo: 5, name: 'FIRE SAFETY CERTIFICATE', pdfUrl: null },
//     { sNo: 6, name: 'WATER HEALTH & SANITARY CERTIFICATE', pdfUrl: null },
//     { sNo: 7, name: 'FEE STRUCTURE OF THE SCHOOL', pdfUrl: null },
//     { sNo: 8, name: 'ANNUAL ACADEMIC CALENDAR', pdfUrl: null },
//     { sNo: 9, name: 'SMC', pdfUrl: null },
//     { sNo: 10, name: 'PTA', pdfUrl: null },
//     { sNo: 11, name: 'RTE', pdfUrl: null },
//     { sNo: 12, name: 'TEACHING STAFF', pdfUrl: null },
//     { sNo: 13, name: 'CERTIFICATE OF LAND', pdfUrl: null },
//     { sNo: 14, name: 'SELF CERTIFICATE', pdfUrl: null },
//     { sNo: 15, name: 'LIBRARY', pdfUrl: null },
//     { sNo: 16, name: 'SCHOOL COMPOUND', pdfUrl: null },
//     { sNo: 17, name: 'CSWN – BOYS & GIRLS', pdfUrl: null },
//     { sNo: 18, name: 'SCIENCE LAB', pdfUrl: null },
//     { sNo: 19, name: 'SCHOOL ENTRY VIEW & CLASS ROOMS', pdfUrl: null },
//     { sNo: 20, name: 'COMPUTER LAB', pdfUrl: null },
//   ]);
//   const [loading, setLoading] = useState(true);

//   useEffect(() => {
//     fetchDocuments();
//   }, []);

//   const fetchDocuments = async () => {
//     try {
//       const docsRef = ref(database, 'school/documents');
//       const snapshot = await get(docsRef);
//       if (snapshot.exists()) {
//         const storedDocs = snapshot.val();
//         setDocuments((prevDocs) =>
//           prevDocs.map((doc) => ({
//             ...doc,
//             pdfUrl: storedDocs[doc.sNo]?.pdfUrl || null,
//           }))
//         );
//       } else {
//         toast.info('No documents available in the database');
//       }
//       setLoading(false);
//     } catch (error) {
//       console.error('Error fetching documents:', error);
//       toast.error('Failed to load documents: ' + error.message);
//       setLoading(false);
//     }
//   };

//   const handleFileUpload = async (event, sNo, isEdit = false) => {
//     const file = event.target.files[0];
//     if (!file || file.type !== 'application/pdf') {
//       toast.error('Please upload a valid PDF file');
//       return;
//     }

//     try {
//       setLoading(true);
//       const fileRef = storageRef(storage, `school/documents/${sNo}_${file.name}`);
//       await uploadBytes(fileRef, file);
//       const downloadUrl = await getDownloadURL(fileRef);

//       const docRef = ref(database, `school/documents/${sNo}`);
//       await set(docRef, { pdfUrl: downloadUrl });

//       setDocuments((prevDocs) =>
//         prevDocs.map((doc) =>
//           doc.sNo === sNo ? { ...doc, pdfUrl: downloadUrl } : doc
//         )
//       );
//       toast.success(isEdit ? 'PDF edited successfully' : 'PDF uploaded successfully');
//       setLoading(false);
//     } catch (error) {
//       console.error('Error uploading PDF:', error);
//       toast.error((isEdit ? 'Failed to edit PDF' : 'Failed to upload PDF') + ': ' + error.message);
//       setLoading(false);
//     }
//   };

//   const handleDelete = async (sNo) => {
//     try {
//       setLoading(true);

//       const doc = documents.find((d) => d.sNo === sNo);
//       if (!doc?.pdfUrl) {
//         toast.error('No file to delete');
//         setLoading(false);
//         return;
//       }

//       const decodedUrl = decodeURIComponent(doc.pdfUrl);
//       const pathStartIndex = decodedUrl.indexOf('/o/') + 3;
//       const pathEndIndex = decodedUrl.indexOf('?');
//       const filePath = decodedUrl.substring(pathStartIndex, pathEndIndex).replace(/%2F/g, '/');

//       const fileRef = storageRef(storage, filePath);
//       await deleteObject(fileRef);

//       const docRef = ref(database, `school/documents/${sNo}`);
//       await set(docRef, null);

//       setDocuments((prevDocs) =>
//         prevDocs.map((doc) =>
//           doc.sNo === sNo ? { ...doc, pdfUrl: null } : doc
//         )
//       );

//       toast.success('Document deleted successfully');
//       setLoading(false);
//     } catch (error) {
//       console.error('Error deleting document:', error);
//       toast.error('Failed to delete document: ' + error.message);
//       setLoading(false);
//     }
//   };

//   return (
//     <div className="users-table-wrapper">
//       <table className="users-table">
//         <thead>
//           <tr>
//             <th>S.No</th>
//             <th>Document/Information</th>
//             <th>Action</th>
//           </tr>
//         </thead>
//         <tbody>
//           {documents.map((doc) => (
//             <tr key={doc.sNo}>
//               <td>{doc.sNo}</td>
//               <td>{doc.name}</td>
//               <td>
//                 {doc.pdfUrl ? (
//                   <div style={{ display: 'flex', gap: '10px', alignItems: 'center' }}>
//                     <a
//                       href={doc.pdfUrl}
//                       target="_blank"
//                       rel="noopener noreferrer"
//                       style={{
//                         color: '#2874f0',
//                         textDecoration: 'none',
//                       }}
//                     >
//                       View PDF
//                     </a>
//                     <label
//                       style={{
//                         background: '#ff9800',
//                         color: 'white',
//                         padding: '8px 12px',
//                         borderRadius: '6px',
//                         cursor: 'pointer',
//                         fontSize: '14px',
//                       }}
//                     >
//                       Edit
//                       <input
//                         type="file"
//                         accept=".pdf"
//                         onChange={(e) => handleFileUpload(e, doc.sNo, true)}
//                         style={{ display: 'none' }}
//                       />
//                     </label>
//                     <button
//                       onClick={() => handleDelete(doc.sNo)}
//                       style={{
//                         background: '#e53935',
//                         color: 'white',
//                         padding: '8px 12px',
//                         borderRadius: '6px',
//                         border: 'none',
//                         cursor: 'pointer',
//                         fontSize: '14px',
//                       }}
//                     >
//                       Delete
//                     </button>
//                   </div>
//                 ) : (
//                   <label
//                     style={{
//                       background: '#2874f0',
//                       color: 'white',
//                       padding: '8px 12px',
//                       borderRadius: '6px',
//                       cursor: 'pointer',
//                       fontSize: '14px',
//                     }}
//                   >
//                     Upload PDF
//                     <input
//                       type="file"
//                       accept=".pdf"
//                       onChange={(e) => handleFileUpload(e, doc.sNo, false)}
//                       style={{ display: 'none' }}
//                     />
//                   </label>
//                 )}
//               </td>
//             </tr>
//           ))}
//         </tbody>
//       </table>
//       {loading && (
//         <div style={{ textAlign: 'center', padding: '20px' }}>
//           Loading documents...
//         </div>
//       )}
//     </div>
//   );
// };

// export default OrderDocumentsTable;






// import React, { useState, useEffect } from 'react';
// import { ref, get, set, push, remove } from 'firebase/database';
// import { ref as storageRef, uploadBytes, getDownloadURL, deleteObject } from 'firebase/storage';
// import { database, storage } from '../firebase';
// import { toast } from 'react-toastify';

// const OrderDocumentsTable = () => {
//   // PDF Documents State
//   const [documents, setDocuments] = useState([
//     { sNo: 1, name: 'TRUST REGISTRATION', pdfUrl: null },
//     { sNo: 2, name: 'NOC', pdfUrl: null },
//     { sNo: 3, name: 'RECOGNITION CERTIFICATE', pdfUrl: null },
//     { sNo: 4, name: 'BUILDING SAFETY CERTIFICATE', pdfUrl: null },
//     { sNo: 5, name: 'FIRE SAFETY CERTIFICATE', pdfUrl: null },
//     { sNo: 6, name: 'WATER HEALTH & SANITARY CERTIFICATE', pdfUrl: null },
//     { sNo: 7, name: 'FEE STRUCTURE OF THE SCHOOL', pdfUrl: null },
//     { sNo: 8, name: 'ANNUAL ACADEMIC CALENDAR', pdfUrl: null },
//     { sNo: 9, name: 'SMC', pdfUrl: null },
//     { sNo: 10, name: 'PTA', pdfUrl: null },
//     { sNo: 11, name: 'RTE', pdfUrl: null },
//     { sNo: 12, name: 'TEACHING STAFF', pdfUrl: null },
//     { sNo: 13, name: 'CERTIFICATE OF LAND', pdfUrl: null },
//     { sNo: 14, name: 'SELF CERTIFICATE', pdfUrl: null },
//     { sNo: 15, name: 'LIBRARY', pdfUrl: null },
//     { sNo: 16, name: 'SCHOOL COMPOUND', pdfUrl: null },
//     { sNo: 17, name: 'CSWN – BOYS & GIRLS', pdfUrl: null },
//     { sNo: 18, name: 'SCIENCE LAB', pdfUrl: null },
//     { sNo: 19, name: 'SCHOOL ENTRY VIEW & CLASS ROOMS', pdfUrl: null },
//     { sNo: 20, name: 'COMPUTER LAB', pdfUrl: null },
//   ]);

//   // Videos State
//   const [videos, setVideos] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [editingVideoId, setEditingVideoId] = useState(null);
//   const [youtubeUrlInput, setYoutubeUrlInput] = useState('');
//   const [videoTitleInput, setVideoTitleInput] = useState('');

//   // Fetch initial data
//   useEffect(() => {
//     const fetchData = async () => {
//       try {
//         await fetchDocuments();
//         await fetchVideos();
//         setLoading(false);
//       } catch (error) {
//         console.error('Error fetching data:', error);
//         toast.error('Failed to load data: ' + error.message);
//         setLoading(false);
//       }
//     };
//     fetchData();
//   }, []);

//   // Fetch PDF documents from Firebase
//   const fetchDocuments = async () => {
//     const docsRef = ref(database, 'school/documents');
//     const snapshot = await get(docsRef);
//     if (snapshot.exists()) {
//       const storedDocs = snapshot.val();
//       setDocuments(prevDocs =>
//         prevDocs.map(doc => ({
//           ...doc,
//           pdfUrl: storedDocs[doc.sNo]?.pdfUrl || null,
//         }))
//       );
//     }
//   };

//   // Fetch videos from Firebase
//   const fetchVideos = async () => {
//     const videosRef = ref(database, 'school/videos');
//     const snapshot = await get(videosRef);
//     if (snapshot.exists()) {
//       const videosData = snapshot.val();
//       const videosArray = Object.keys(videosData).map(key => ({
//         id: key,
//         ...videosData[key],
//       }));
//       setVideos(videosArray);
//     }
//   };

//   // Handle PDF upload
//   const handleFileUpload = async (event, sNo) => {
//     const file = event.target.files[0];
//     if (!file || file.type !== 'application/pdf') {
//       toast.error('Please upload a valid PDF file');
//       return;
//     }

//     try {
//       setLoading(true);
//       const fileRef = storageRef(storage, `school/documents/${sNo}_${file.name}`);
//       await uploadBytes(fileRef, file);
//       const downloadUrl = await getDownloadURL(fileRef);

//       const docRef = ref(database, `school/documents/${sNo}`);
//       await set(docRef, {
//         name: documents.find(d => d.sNo === sNo).name,
//         pdfUrl: downloadUrl,
//       });

//       setDocuments(prevDocs =>
//         prevDocs.map(doc =>
//           doc.sNo === sNo ? { ...doc, pdfUrl: downloadUrl } : doc
//         )
//       );
//       toast.success('PDF uploaded successfully');
//     } catch (error) {
//       console.error('Error uploading PDF:', error);
//       toast.error('Failed to upload PDF: ' + error.message);
//     } finally {
//       setLoading(false);
//     }
//   };

//   // Handle PDF deletion
//   const handleDeletePdf = async (sNo) => {
//     try {
//       setLoading(true);
//       const doc = documents.find(d => d.sNo === sNo);
      
//       if (doc?.pdfUrl) {
//         // Delete file from storage
//         const decodedUrl = decodeURIComponent(doc.pdfUrl);
//         const pathStart = decodedUrl.indexOf('/o/') + 3;
//         const pathEnd = decodedUrl.indexOf('?');
//         const filePath = decodedUrl.substring(pathStart, pathEnd).replace(/%2F/g, '/');
//         const fileRef = storageRef(storage, filePath);
//         await deleteObject(fileRef);
//       }

//       // Remove from database
//       const docRef = ref(database, `school/documents/${sNo}`);
//       await set(docRef, null);

//       // Update local state
//       setDocuments(prevDocs =>
//         prevDocs.map(doc =>
//           doc.sNo === sNo ? { ...doc, pdfUrl: null } : doc
//         )
//       );
//       toast.success('PDF deleted successfully');
//     } catch (error) {
//       console.error('Error deleting PDF:', error);
//       toast.error('Failed to delete PDF: ' + error.message);
//     } finally {
//       setLoading(false);
//     }
//   };

//   // Handle video submission (add or edit)
//   const handleVideoSubmit = async () => {
//     if (!videoTitleInput || !youtubeUrlInput) {
//       toast.error('Please enter both title and YouTube URL');
//       return;
//     }

//     // Extract YouTube video ID
//     const regExp = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|&v=)([^#&?]*).*/;
//     const match = youtubeUrlInput.match(regExp);
//     const videoId = (match && match[2].length === 11) ? match[2] : null;

//     if (!videoId) {
//       toast.error('Please enter a valid YouTube URL');
//       return;
//     }

//     try {
//       setLoading(true);
//       const videoData = {
//         title: videoTitleInput,
//         url: `https://www.youtube.com/watch?v=${videoId}`,
//         embedUrl: `https://www.youtube.com/embed/${videoId}`,
//         createdAt: new Date().toISOString(),
//       };

//       if (editingVideoId) {
//         // Update existing video
//         const videoRef = ref(database, `school/videos/${editingVideoId}`);
//         await set(videoRef, videoData);
//         setVideos(prev =>
//           prev.map(v => (v.id === editingVideoId ? { id: v.id, ...videoData } : v))
//         );
//         toast.success('Video updated successfully');
//       } else {
//         // Add new video
//         const newVideoRef = push(ref(database, 'school/videos'));
//         await set(newVideoRef, videoData);
//         setVideos(prev => [...prev, { id: newVideoRef.key, ...videoData }]);
//         toast.success('Video added successfully');
//       }

//       // Reset form
//       setVideoTitleInput('');
//       setYoutubeUrlInput('');
//       setEditingVideoId(null);
//     } catch (error) {
//       console.error('Error saving video:', error);
//       toast.error('Failed to save video: ' + error.message);
//     } finally {
//       setLoading(false);
//     }
//   };

//   // Handle video deletion
//   const handleDeleteVideo = async (videoId) => {
//     try {
//       setLoading(true);
//       await remove(ref(database, `school/videos/${videoId}`));
//       setVideos(prev => prev.filter(v => v.id !== videoId));
//       toast.success('Video deleted successfully');
//     } catch (error) {
//       console.error('Error deleting video:', error);
//       toast.error('Failed to delete video: ' + error.message);
//     } finally {
//       setLoading(false);
//     }
//   };

//   // Start editing a video
//   const startEditingVideo = (video) => {
//     setEditingVideoId(video.id);
//     setVideoTitleInput(video.title);
//     setYoutubeUrlInput(video.url);
//   };

//   // Cancel editing
//   const cancelEditing = () => {
//     setEditingVideoId(null);
//     setVideoTitleInput('');
//     setYoutubeUrlInput('');
//   };

//   return (
//     <div style={{ maxWidth: '1200px', margin: '0 auto', padding: '20px' }}>
//       {/* PDF Documents Section */}
//       <section style={{ marginBottom: '40px' }}>
//         <h2 style={{ color: '#333', marginBottom: '20px' }}>School Documents</h2>
//         <div style={{ overflowX: 'auto' }}>
//           <table style={{ width: '100%', borderCollapse: 'collapse' }}>
//             <thead>
//               <tr style={{ backgroundColor: '#f5f5f5' }}>
//                 <th style={{ padding: '12px', textAlign: 'left', borderBottom: '1px solid #ddd' }}>S.No</th>
//                 <th style={{ padding: '12px', textAlign: 'left', borderBottom: '1px solid #ddd' }}>Document</th>
//                 <th style={{ padding: '12px', textAlign: 'left', borderBottom: '1px solid #ddd' }}>Actions</th>
//               </tr>
//             </thead>
//             <tbody>
//               {documents.map(doc => (
//                 <tr key={doc.sNo} style={{ borderBottom: '1px solid #eee' }}>
//                   <td style={{ padding: '12px' }}>{doc.sNo}</td>
//                   <td style={{ padding: '12px' }}>{doc.name}</td>
//                   <td style={{ padding: '12px' }}>
//                     {doc.pdfUrl ? (
//                       <div style={{ display: 'flex', gap: '10px' }}>
//                         <a
//                           href={doc.pdfUrl}
//                           target="_blank"
//                           rel="noopener noreferrer"
//                           style={{
//                             color: '#2874f0',
//                             textDecoration: 'none',
//                             padding: '8px 12px',
//                             border: '1px solid #2874f0',
//                             borderRadius: '4px',
//                           }}
//                         >
//                           View PDF
//                         </a>
//                         <label
//                           style={{
//                             background: '#ff9800',
//                             color: 'white',
//                             padding: '8px 12px',
//                             borderRadius: '4px',
//                             cursor: 'pointer',
//                           }}
//                         >
//                           Replace
//                           <input
//                             type="file"
//                             accept=".pdf"
//                             onChange={(e) => handleFileUpload(e, doc.sNo)}
//                             style={{ display: 'none' }}
//                             disabled={loading}
//                           />
//                         </label>
//                         <button
//                           onClick={() => handleDeletePdf(doc.sNo)}
//                           style={{
//                             background: '#e53935',
//                             color: 'white',
//                             padding: '8px 12px',
//                             borderRadius: '4px',
//                             border: 'none',
//                             cursor: 'pointer',
//                           }}
//                           disabled={loading}
//                         >
//                           Delete
//                         </button>
//                       </div>
//                     ) : (
//                       <label
//                         style={{
//                           background: '#2874f0',
//                           color: 'white',
//                           padding: '8px 12px',
//                           borderRadius: '4px',
//                           cursor: 'pointer',
//                           display: 'inline-block',
//                         }}
//                       >
//                         Upload PDF
//                         <input
//                           type="file"
//                           accept=".pdf"
//                           onChange={(e) => handleFileUpload(e, doc.sNo)}
//                           style={{ display: 'none' }}
//                           disabled={loading}
//                         />
//                       </label>
//                     )}
//                   </td>
//                 </tr>
//               ))}
//             </tbody>
//           </table>
//         </div>
//       </section>

//       {/* Videos Section */}
//       <section>
//         <h2 style={{ color: '#333', marginBottom: '20px' }}>School Videos</h2>
        
//         {/* Video Form */}
//         <div style={{
//           backgroundColor: '#f9f9f9',
//           padding: '20px',
//           borderRadius: '8px',
//           marginBottom: '20px',
//           border: '1px solid #eee'
//         }}>
//           <h3 style={{ marginTop: 0, marginBottom: '15px' }}>
//             {editingVideoId ? 'Edit Video' : 'Add New Video'}
//           </h3>
//           <div style={{ display: 'grid', gap: '15px' }}>
//             <div>
//               <label style={{ display: 'block', marginBottom: '5px', fontWeight: '500' }}>
//                 Video Title
//               </label>
//               <input
//                 type="text"
//                 value={videoTitleInput}
//                 onChange={(e) => setVideoTitleInput(e.target.value)}
//                 placeholder="Enter video title"
//                 style={{
//                   width: '100%',
//                   padding: '10px',
//                   borderRadius: '4px',
//                   border: '1px solid #ddd',
//                   fontSize: '16px',
//                 }}
//               />
//             </div>
//             <div>
//               <label style={{ display: 'block', marginBottom: '5px', fontWeight: '500' }}>
//                 YouTube URL
//               </label>
//               <input
//                 type="text"
//                 value={youtubeUrlInput}
//                 onChange={(e) => setYoutubeUrlInput(e.target.value)}
//                 placeholder="https://www.youtube.com/watch?v=..."
//                 style={{
//                   width: '100%',
//                   padding: '10px',
//                   borderRadius: '4px',
//                   border: '1px solid #ddd',
//                   fontSize: '16px',
//                 }}
//               />
//             </div>
//             <div style={{ display: 'flex', gap: '10px', marginTop: '10px' }}>
//               <button
//                 onClick={handleVideoSubmit}
//                 style={{
//                   background: '#4CAF50',
//                   color: 'white',
//                   padding: '10px 20px',
//                   borderRadius: '4px',
//                   border: 'none',
//                   cursor: 'pointer',
//                   fontSize: '16px',
//                 }}
//                 disabled={loading}
//               >
//                 {editingVideoId ? 'Update Video' : 'Add Video'}
//               </button>
//               {editingVideoId && (
//                 <button
//                   onClick={cancelEditing}
//                   style={{
//                     background: '#f44336',
//                     color: 'white',
//                     padding: '10px 20px',
//                     borderRadius: '4px',
//                     border: 'none',
//                     cursor: 'pointer',
//                     fontSize: '16px',
//                   }}
//                 >
//                   Cancel
//                 </button>
//               )}
//             </div>
//           </div>
//         </div>

//         {/* Videos Grid */}
//         {videos.length > 0 ? (
//           <div style={{
//             display: 'grid',
//             gridTemplateColumns: 'repeat(auto-fill, minmax(300px, 1fr))',
//             gap: '20px',
//           }}>
//             {videos.map(video => (
//               <div key={video.id} style={{
//                 border: '1px solid #eee',
//                 borderRadius: '8px',
//                 overflow: 'hidden',
//                 boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
//               }}>
//                 <div style={{ padding: '15px', backgroundColor: '#f5f5f5' }}>
//                   <h4 style={{ margin: 0 }}>{video.title}</h4>
//                 </div>
//                 <div style={{ padding: '15px' }}>
//                   <div style={{
//                     position: 'relative',
//                     paddingBottom: '56.25%', /* 16:9 aspect ratio */
//                     height: 0,
//                     overflow: 'hidden',
//                     marginBottom: '15px',
//                   }}>
//                     <iframe
//                       style={{
//                         position: 'absolute',
//                         top: 0,
//                         left: 0,
//                         width: '100%',
//                         height: '100%',
//                         border: 'none',
//                       }}
//                       src={video.embedUrl}
//                       title={video.title}
//                       allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
//                       allowFullScreen
//                     ></iframe>
//                   </div>
//                   <div style={{
//                     display: 'flex',
//                     gap: '10px',
//                     flexWrap: 'wrap',
//                   }}>
//                     <button
//                       onClick={() => startEditingVideo(video)}
//                       style={{
//                         background: '#ff9800',
//                         color: 'white',
//                         padding: '8px 12px',
//                         borderRadius: '4px',
//                         border: 'none',
//                         cursor: 'pointer',
//                         fontSize: '14px',
//                       }}
//                     >
//                       Edit
//                     </button>
//                     <button
//                       onClick={() => handleDeleteVideo(video.id)}
//                       style={{
//                         background: '#e53935',
//                         color: 'white',
//                         padding: '8px 12px',
//                         borderRadius: '4px',
//                         border: 'none',
//                         cursor: 'pointer',
//                         fontSize: '14px',
//                       }}
//                     >
//                       Delete
//                     </button>
//                     <a
//                       href={video.url}
//                       target="_blank"
//                       rel="noopener noreferrer"
//                       style={{
//                         background: '#2874f0',
//                         color: 'white',
//                         padding: '8px 12px',
//                         borderRadius: '4px',
//                         textDecoration: 'none',
//                         fontSize: '14px',
//                       }}
//                     >
//                       Watch on YouTube
//                     </a>
//                   </div>
//                 </div>
//               </div>
//             ))}
//           </div>
//         ) : (
//           <div style={{
//             padding: '40px',
//             textAlign: 'center',
//             border: '1px dashed #ddd',
//             borderRadius: '8px',
//             backgroundColor: '#f9f9f9',
//           }}>
//             <p style={{ color: '#666' }}>No videos added yet. Add your first video above.</p>
//           </div>
//         )}
//       </section>

//       {/* Loading Indicator */}
//       {loading && (
//         <div style={{
//           position: 'fixed',
//           top: 0,
//           left: 0,
//           right: 0,
//           bottom: 0,
//           backgroundColor: 'rgba(0,0,0,0.5)',
//           display: 'flex',
//           justifyContent: 'center',
//           alignItems: 'center',
//           zIndex: 1000,
//         }}>
//           <div style={{
//             backgroundColor: 'white',
//             padding: '30px',
//             borderRadius: '8px',
//             boxShadow: '0 2px 10px rgba(0,0,0,0.2)',
//           }}>
//             <p style={{ margin: 0, fontSize: '18px' }}>Processing, please wait...</p>
//           </div>
//         </div>
//       )}
//     </div>
//   );
// };

// export default OrderDocumentsTable;





import React, { useState, useEffect } from 'react';
import { ref, get, set } from 'firebase/database';
import { ref as storageRef, uploadBytes, getDownloadURL, deleteObject } from 'firebase/storage';
import { database, storage } from '../firebase';
import { toast } from 'react-toastify';

const OrderDocumentsTable = () => {
  const [documents, setDocuments] = useState([
    { sNo: 1, name: 'TRUST REGISTRATION', pdfUrl: null, youtubeUrl: null },
    { sNo: 2, name: 'NOC', pdfUrl: null, youtubeUrl: null },
    { sNo: 3, name: 'RECOGNITION CERTIFICATE', pdfUrl: null, youtubeUrl: null },
    { sNo: 4, name: 'BUILDING SAFETY CERTIFICATE', pdfUrl: null, youtubeUrl: null },
    { sNo: 5, name: 'FIRE SAFETY CERTIFICATE', pdfUrl: null, youtubeUrl: null },
    { sNo: 6, name: 'WATER HEALTH & SANITARY CERTIFICATE', pdfUrl: null, youtubeUrl: null },
    { sNo: 7, name: 'FEE STRUCTURE OF THE SCHOOL', pdfUrl: null, youtubeUrl: null },
    { sNo: 8, name: 'ANNUAL ACADEMIC CALENDAR', pdfUrl: null, youtubeUrl: null },
    { sNo: 9, name: 'SMC', pdfUrl: null, youtubeUrl: null },
    { sNo: 10, name: 'PTA', pdfUrl: null, youtubeUrl: null },
    { sNo: 11, name: 'RTE', pdfUrl: null, youtubeUrl: null },
    { sNo: 12, name: 'TEACHING STAFF', pdfUrl: null, youtubeUrl: null },
    { sNo: 13, name: 'CERTIFICATE OF LAND', pdfUrl: null, youtubeUrl: null },
    { sNo: 14, name: 'SELF CERTIFICATE', pdfUrl: null, youtubeUrl: null },
  ]);
  const [loading, setLoading] = useState(true);
  const [editingVideo, setEditingVideo] = useState(null);
  const [youtubeUrlInput, setYoutubeUrlInput] = useState('');

  useEffect(() => {
    fetchDocuments();
  }, []);

  const fetchDocuments = async () => {
    try {
      const docsRef = ref(database, 'school/documents');
      const snapshot = await get(docsRef);
      if (snapshot.exists()) {
        const storedDocs = snapshot.val();
        setDocuments((prevDocs) =>
          prevDocs.map((doc) => {
            const storedDoc = storedDocs[doc.sNo] || {};
            return {
              ...doc,
              pdfUrl: storedDoc.pdfUrl || null,
              youtubeUrl: storedDoc.youtubeUrl || null,
              pdfApplicable: storedDoc.pdfApplicable !== undefined ? storedDoc.pdfApplicable : true,
              youtubeApplicable: storedDoc.youtubeApplicable !== undefined ? storedDoc.youtubeApplicable : (doc.sNo >= 15),
            };
          })
        );
      } else {
        toast.info('No documents available in the database');
      }
      setLoading(false);
    } catch (error) {
      console.error('Error fetching documents:', error);
      toast.error('Failed to load documents: ' + error.message);
      setLoading(false);
    }
  };

  const handleToggleApplicable = async (sNo, field, value) => {
    try {
      setLoading(true);
      const docRef = ref(database, `school/documents/${sNo}`);
      await set(docRef, { 
        ...documents.find(doc => doc.sNo === sNo),
        [field]: value 
      });

      setDocuments((prevDocs) =>
        prevDocs.map((doc) =>
          doc.sNo === sNo ? { ...doc, [field]: value } : doc
        )
      );
      toast.success(`${field === 'pdfApplicable' ? 'PDF' : 'YouTube'} option updated`);
      setLoading(false);
    } catch (error) {
      console.error(`Error toggling ${field}:`, error);
      toast.error('Failed to update option: ' + error.message);
      setLoading(false);
    }
  };

  const handleFileUpload = async (event, sNo, isEdit = false) => {
    const file = event.target.files[0];
    if (!file || file.type !== 'application/pdf') {
      toast.error('Please upload a valid PDF file');
      return;
    }

    try {
      setLoading(true);
      const fileRef = storageRef(storage, `school/documents/${sNo}_${file.name}`);
      await uploadBytes(fileRef, file);
      const downloadUrl = await getDownloadURL(fileRef);

      const docRef = ref(database, `school/documents/${sNo}`);
      await set(docRef, { 
        ...documents.find(doc => doc.sNo === sNo),
        pdfUrl: downloadUrl 
      });

      setDocuments((prevDocs) =>
        prevDocs.map((doc) =>
          doc.sNo === sNo ? { ...doc, pdfUrl: downloadUrl } : doc
        )
      );
      toast.success(isEdit ? 'PDF edited successfully' : 'PDF uploaded successfully');
      setLoading(false);
    } catch (error) {
      console.error('Error uploading PDF:', error);
      toast.error((isEdit ? 'Failed to edit PDF' : 'Failed to upload PDF') + ': ' + error.message);
      setLoading(false);
    }
  };

  const handleDelete = async (sNo, type) => {
    try {
      setLoading(true);

      const doc = documents.find((d) => d.sNo === sNo);
      if (!doc) {
        toast.error('Document not found');
        setLoading(false);
        return;
      }

      if (type === 'pdf' && doc.pdfUrl) {
        const decodedUrl = decodeURIComponent(doc.pdfUrl);
        const pathStartIndex = decodedUrl.indexOf('/o/') + 3;
        const pathEndIndex = decodedUrl.indexOf('?');
        const filePath = decodedUrl.substring(pathStartIndex, pathEndIndex).replace(/%2F/g, '/');
        const fileRef = storageRef(storage, filePath);
        await deleteObject(fileRef);
      }

      const docRef = ref(database, `school/documents/${sNo}`);
      await set(docRef, {
        ...doc,
        [type === 'pdf' ? 'pdfUrl' : 'youtubeUrl']: null
      });

      setDocuments((prevDocs) =>
        prevDocs.map((doc) =>
          doc.sNo === sNo ? { ...doc, [type === 'pdf' ? 'pdfUrl' : 'youtubeUrl']: null } : doc
        )
      );

      toast.success(`${type === 'pdf' ? 'PDF' : 'YouTube video'} deleted successfully`);
      setLoading(false);
    } catch (error) {
      console.error(`Error deleting ${type}:`, error);
      toast.error(`Failed to delete ${type === 'pdf' ? 'PDF' : 'YouTube video'}: ` + error.message);
      setLoading(false);
    }
  };

  const handleAddYoutubeUrl = async (sNo) => {
    if (!youtubeUrlInput) {
      toast.error('Please enter a YouTube URL');
      return;
    }

    if (!youtubeUrlInput.includes('youtube.com') && !youtubeUrlInput.includes('youtu.be')) {
      toast.error('Please enter a valid YouTube URL');
      return;
    }

    try {
      setLoading(true);
      const docRef = ref(database, `school/documents/${sNo}`);
      await set(docRef, { 
        ...documents.find(doc => doc.sNo === sNo),
        youtubeUrl: youtubeUrlInput 
      });

      setDocuments((prevDocs) =>
        prevDocs.map((doc) =>
          doc.sNo === sNo ? { ...doc, youtubeUrl: youtubeUrlInput } : doc
        )
      );
      
      setEditingVideo(null);
      setYoutubeUrlInput('');
      toast.success('YouTube video added successfully');
      setLoading(false);
    } catch (error) {
      console.error('Error adding YouTube URL:', error);
      toast.error('Failed to add YouTube URL: ' + error.message);
      setLoading(false);
    }
  };

  const extractYoutubeId = (url) => {
    const regExp = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|&v=)([^#&?]*).*/;
    const match = url?.match(regExp);
    return (match && match[2].length === 11) ? match[2] : null;
  };

  return (
    <div style={{ maxWidth: '1200px', margin: '0 auto', padding: '20px' }}>
      <table style={{ width: '100%', borderCollapse: 'collapse', marginBottom: '40px' }}>
        <thead>
          <tr style={{ backgroundColor: '#f5f5f5' }}>
            <th style={{ padding: '12px', textAlign: 'left', borderBottom: '1px solid #ddd' }}>S.No</th>
            <th style={{ padding: '12px', textAlign: 'left', borderBottom: '1px solid #ddd' }}>Document/Information</th>
            <th style={{ padding: '12px', textAlign: 'left', borderBottom: '1px solid #ddd' }}>PDF</th>
            <th style={{ padding: '12px', textAlign: 'left', borderBottom: '1px solid #ddd' }}>YouTube Video</th>
          </tr>
        </thead>
        <tbody>
          {documents.map((doc) => (
            <tr key={doc.sNo} style={{ borderBottom: '1px solid #eee' }}>
              <td style={{ padding: '12px' }}>{doc.sNo}</td>
              <td style={{ padding: '12px' }}>{doc.name}</td>
              <td style={{ padding: '12px' }}>
                {doc.pdfApplicable === false ? (
                  <div style={{ display: 'flex', gap: '10px', alignItems: 'center' }}>
                    <span style={{ color: '#999', fontStyle: 'italic' }}>Not applicable</span>
                    <button
                      onClick={() => handleToggleApplicable(doc.sNo, 'pdfApplicable', true)}
                      style={{ background: '#4CAF50', color: 'white', padding: '4px 8px', borderRadius: '4px', border: 'none', cursor: 'pointer', fontSize: '12px' }}
                      disabled={loading}
                    >
                      Enable
                    </button>
                  </div>
                ) : (
                  <div>
                    <div style={{ marginBottom: '8px' }}>
                      <button
                        onClick={() => handleToggleApplicable(doc.sNo, 'pdfApplicable', false)}
                        style={{ background: '#f44336', color: 'white', padding: '4px 8px', borderRadius: '4px', border: 'none', cursor: 'pointer', fontSize: '12px' }}
                        disabled={loading}
                      >
                        Disable Option
                      </button>
                    </div>
                {doc.pdfUrl ? (
                  <div style={{ display: 'flex', gap: '10px', alignItems: 'center' }}>
                    <a
                      href={doc.pdfUrl}
                      target="_blank"
                      rel="noopener noreferrer"
                      style={{
                        color: '#2874f0',
                        textDecoration: 'none',
                        padding: '8px 12px',
                        border: '1px solid #2874f0',
                        borderRadius: '4px',
                      }}
                    >
                      View PDF
                    </a>
                    <label
                      style={{
                        background: '#ff9800',
                        color: 'white',
                        padding: '8px 12px',
                        borderRadius: '4px',
                        cursor: 'pointer',
                      }}
                    >
                      Replace
                      <input
                        type="file"
                        accept=".pdf"
                        onChange={(e) => handleFileUpload(e, doc.sNo)}
                        style={{ display: 'none' }}
                        disabled={loading}
                      />
                    </label>
                    <button
                      onClick={() => handleDelete(doc.sNo, 'pdf')}
                      style={{
                        background: '#e53935',
                        color: 'white',
                        padding: '8px 12px',
                        borderRadius: '4px',
                        border: 'none',
                        cursor: 'pointer',
                      }}
                      disabled={loading}
                    >
                      Delete
                    </button>
                  </div>
                ) : (
                  <label
                    style={{
                      background: '#2874f0',
                      color: 'white',
                      padding: '8px 12px',
                      borderRadius: '4px',
                      cursor: 'pointer',
                      display: 'inline-block',
                    }}
                  >
                    Upload PDF
                    <input
                      type="file"
                      accept=".pdf"
                      onChange={(e) => handleFileUpload(e, doc.sNo)}
                      style={{ display: 'none' }}
                      disabled={loading}
                    />
                  </label>
                )}
                  </div>
                )}
              </td>
              <td style={{ padding: '12px' }}>
                {doc.youtubeApplicable === false ? (
                  <div style={{ display: 'flex', gap: '10px', alignItems: 'center' }}>
                    <span style={{ color: '#999', fontStyle: 'italic' }}>Not applicable</span>
                    <button
                      onClick={() => handleToggleApplicable(doc.sNo, 'youtubeApplicable', true)}
                      style={{ background: '#4CAF50', color: 'white', padding: '4px 8px', borderRadius: '4px', border: 'none', cursor: 'pointer', fontSize: '12px' }}
                      disabled={loading}
                    >
                      Enable
                    </button>
                  </div>
                ) : (
                  <div>
                    <div style={{ marginBottom: '8px' }}>
                      <button
                        onClick={() => handleToggleApplicable(doc.sNo, 'youtubeApplicable', false)}
                        style={{ background: '#f44336', color: 'white', padding: '4px 8px', borderRadius: '4px', border: 'none', cursor: 'pointer', fontSize: '12px' }}
                        disabled={loading}
                      >
                        Disable Option
                      </button>
                    </div>
                  {editingVideo === doc.sNo ? (
                    <div style={{ display: 'flex', gap: '10px', alignItems: 'center' }}>
                      <input
                        type="text"
                        value={youtubeUrlInput}
                        onChange={(e) => setYoutubeUrlInput(e.target.value)}
                        placeholder="Enter YouTube URL"
                        style={{
                          padding: '8px',
                          borderRadius: '4px',
                          border: '1px solid #ddd',
                          flex: 1,
                        }}
                      />
                      <button
                        onClick={() => handleAddYoutubeUrl(doc.sNo)}
                        style={{
                          background: '#4CAF50',
                          color: 'white',
                          padding: '8px 12px',
                          borderRadius: '4px',
                          border: 'none',
                          cursor: 'pointer',
                        }}
                        disabled={loading}
                      >
                        Save
                      </button>
                      <button
                        onClick={() => {
                          setEditingVideo(null);
                          setYoutubeUrlInput('');
                        }}
                        style={{
                          background: '#f44336',
                          color: 'white',
                          padding: '8px 12px',
                          borderRadius: '4px',
                          border: 'none',
                          cursor: 'pointer',
                        }}
                      >
                        Cancel
                      </button>
                    </div>
                  ) : doc.youtubeUrl ? (
                    <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
                      <div style={{ display: 'flex', gap: '10px', alignItems: 'center' }}>
                        <a
                          href={doc.youtubeUrl}
                          target="_blank"
                          rel="noopener noreferrer"
                          style={{
                            color: '#2874f0',
                            textDecoration: 'none',
                          }}
                        >
                          Watch Video
                        </a>
                        <button
                          onClick={() => {
                            setEditingVideo(doc.sNo);
                            setYoutubeUrlInput(doc.youtubeUrl);
                          }}
                          style={{
                            background: '#ff9800',
                            color: 'white',
                            padding: '8px 12px',
                            borderRadius: '4px',
                            border: 'none',
                            cursor: 'pointer',
                          }}
                          disabled={loading}
                        >
                          Edit
                        </button>
                        <button
                          onClick={() => handleDelete(doc.sNo, 'youtube')}
                          style={{
                            background: '#e53935',
                            color: 'white',
                            padding: '8px 12px',
                            borderRadius: '4px',
                            border: 'none',
                            cursor: 'pointer',
                          }}
                          disabled={loading}
                        >
                          Delete
                        </button>
                      </div>
                      {extractYoutubeId(doc.youtubeUrl) && (
                        <div style={{ marginTop: '10px' }}>
                          <iframe
                            width="260"
                            height="146"
                            src={`https://www.youtube.com/embed/${extractYoutubeId(doc.youtubeUrl)}`}
                            frameBorder="0"
                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                            allowFullScreen
                            title="YouTube video"
                          ></iframe>
                        </div>
                      )}
                    </div>
                  ) : (
                    <button
                      onClick={() => setEditingVideo(doc.sNo)}
                      style={{
                        background: '#4CAF50',
                        color: 'white',
                        padding: '8px 12px',
                        borderRadius: '4px',
                        border: 'none',
                        cursor: 'pointer',
                      }}
                      disabled={loading}
                    >
                      Add Video
                    </button>
                  )}
                  </div>
                )}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
      {loading && (
        <div style={{ textAlign: 'center', padding: '20px' }}>
          Loading documents...
        </div>
      )}
    </div>
  );
};

export default OrderDocumentsTable;